var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoCirtCondensedDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1139.125 811.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M167.75,751.255h-57c-26.25,0-47.25-21.75-47.25-48V428.005c0-14.25-7.5-21.75-21.75-21.75H15.5v-24H41.75c14.25,0,21.75-7.5,21.75-21.75V86.005c0-26.25,21-48,47.25-48h57v24.75h-57c-14.25,0-23.25,9-23.25,23.25v269.25c0,21.75-12.75,34.5-27.75,38.25v1.5c15,3.75,27.75,17.25,27.75,39v269.25c0,14.25,9,23.25,23.25,23.25h57Z",
    style: {
      fill: "#0d3b1e",
      stroke: "#f2f2f3",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.6,638.005H280.4c-37.8,0-66.151-28.351-66.151-66.151V261.892c0-37.8,28.351-66.151,66.151-66.151h88.2c37.8,0,66.15,28.351,66.15,66.151V323h-63v-66.15a2.977,2.977,0,0,0-3.15-3.15H280.4a2.976,2.976,0,0,0-3.15,3.15v321.3a2.977,2.977,0,0,0,3.15,3.151h88.2a2.977,2.977,0,0,0,3.15-3.151V512h63v59.85C434.749,609.654,406.4,638.005,368.6,638.005Z",
    style: {
      fill: "#181717",
      stroke: "#f2f2f3",
      strokeMiterlimit: 10,
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.905,638.005V197h63v441Z",
    style: {
      fill: "#181717",
      stroke: "#f2f2f3",
      strokeMiterlimit: 10,
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.085,638.005l-47.25-179.552H601.064V638.005h-63V197H692.415c39.061,0,66.15,27.091,66.15,66.15V392.3c0,33.39-18.9,57.33-49.14,64.26l55.44,181.442ZM601.064,401.753h91.351a2.975,2.975,0,0,0,3.149-3.15V256.852a2.975,2.975,0,0,0-3.149-3.15H601.064Z",
    style: {
      fill: "#181717",
      stroke: "#f2f2f3",
      strokeMiterlimit: 10,
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.723,253.7v384.3h-63V253.7H762.972V197h220.5v56.7Z",
    style: {
      fill: "#181717",
      stroke: "#f2f2f3",
      strokeMiterlimit: 10,
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.378,726.505c14.25,0,23.25-9,23.25-23.25V434.005c0-21.75,12.75-35.25,27.75-39v-1.5c-15-3.75-27.75-16.5-27.75-38.25V86.005c0-14.25-9-23.25-23.25-23.25h-57V38.005h57c26.25,0,47.25,21.75,47.25,48v274.5c0,14.25,7.5,21.75,21.75,21.75h26.25v24h-26.25c-14.25,0-21.75,7.5-21.75,21.75v275.25c0,26.25-21,48-47.25,48h-57v-24.75Z",
    style: {
      fill: "#0d3b1e",
      stroke: "#f2f2f3",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093.253,61.325l-9.045-9a5.766,5.766,0,0,1-1.665-4.275v-2.97a4.614,4.614,0,0,1,4.725-4.725h5.175a4.614,4.614,0,0,1,4.725,4.725v4.365h-3.375v-4.68a1.063,1.063,0,0,0-1.125-1.125h-5.625a1.063,1.063,0,0,0-1.125,1.125v3.78a1.971,1.971,0,0,0,.54,1.44l9.045,9a5.8,5.8,0,0,1,1.665,4.32V67.31a4.614,4.614,0,0,1-4.725,4.725h-5.175a4.614,4.614,0,0,1-4.725-4.725V62.945h3.375v4.68a1.087,1.087,0,0,0,1.125,1.125h5.625a1.063,1.063,0,0,0,1.125-1.125V62.81A2.007,2.007,0,0,0,1093.253,61.325Z",
    style: {
      fill: "#a6a5a5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118.183,71.945V47.781l-.135.72-5.806,21.194H1110.8l-5.67-21.194-.135-.72V71.945h-3.375v-31.5h4.545l5.355,19.889,5.49-19.889h4.545v31.5Z",
    style: {
      fill: "#a6a5a5"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCirtCondensedDark);
export default __webpack_public_path__ + "static/media/logo-cirt-condensed-dark.e542cc1611abac9d533699e04427c1d4.svg";
export { ForwardRef as ReactComponent };